/**
 * /tutor/abonnement — Abonnement Prof (migration 0691) : état de l'essai ou de
 * l'abonnement, souscrire, gérer. Quand l'accès est terminé, `TutorLayout`
 * affiche le même panneau à la place de tout l'espace prof.
 */

import { useAuth, isAdmin } from '@/lib/auth';
import { useTutorAccess, type TutorAccess } from '@/lib/tutor/subscription';
import { TutorSubscriptionPanel } from '@/features/tutor-subscription/tutor-subscription-panel';

const ADMIN_ACCESS: TutorAccess = {
  allowed: true,
  reason: 'admin',
  trialDays: 7,
  trialEndsAt: null,
  subscription: null,
};

export function TutorSubscriptionPage() {
  const { user, profile } = useAuth();
  const admin = isAdmin(profile, user?.email);
  const access = useTutorAccess(admin ? null : (user?.id ?? null));

  const data = admin ? ADMIN_ACCESS : access.data;
  return (
    <div className="px-4 py-6 md:px-8 md:py-10">
      {data ? (
        <TutorSubscriptionPanel access={data} userId={user?.id ?? null} />
      ) : access.isError ? (
        <p className="text-ink-500 text-center font-sans text-sm">
          Impossible de charger ton abonnement pour le moment. Réessaie dans un instant.
        </p>
      ) : (
        <div className="flex justify-center py-12">
          <div className="border-primary-400 h-6 w-6 animate-spin rounded-full border-2 border-t-transparent" />
        </div>
      )}
    </div>
  );
}
